import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { Redirect, Route, Router } from "react-router-dom";
import EmptyPage from "./modules/core/empty";
import history from "shared/plugins/history";
import { Loading } from "shared/components/loading/loading";
import { store } from "app.store";
import "./themes/css/main.css";
import  { LayoutExternalPage } from "shared/components/layout/layout-external";
import { ConfirmModal } from "shared/components/confirm-modal/confirm-modal";
import { ToastifyComponent } from "shared/components/toastify/toastify";
import { ACCOUNT_CHANGE_PASSWORD_ROUTE, ACCOUNT_EDIT_ROUTE, ACCOUNT_FORGOT_PASSWORD_ROUTE, ACCOUNT_LOGIN_ROUTE, ACCOUNT_REGISTER_ROUTE, ACCOUNT_RESET_PASSWORD_ROUTE, BILLING_ADDRESS_ADD_ROUTE, BILLING_ADDRESS_EDIT_ROUTE, BILLING_ADDRESS_ROUTE, EMPTY_ROUTE, ORDER_ROUTE, ORDER_VIEW_ROUTE, SHIPPING_ADDRESS_ADD_ROUTE, SHIPPING_ADDRESS_EDIT_ROUTE, SHIPPING_ADDRESS_ROUTE } from "shared/constants/routes";
import LoginPage from "modules/login-page/login";
import ResetPasswordPage from "modules/forgot-page/reset-password";
import ForgotPasswordPage from "modules/forgot-page/forgot-password";
import RegisterPage from "modules/register-page/register-page";
import { LayoutInternalPage } from "shared/components/layout/layout-internal";
import UserInfoPage from "modules/user-info-page/user-info-page";
import ChangePasswordPage from "modules/user-info-page/change-password-page";
import AddressPage from "modules/address-page/address-page";
import AddUpdateAddressPage from "modules/address-page/add-update-address";
import OrderPage from "modules/order-page/order-page";
import OrderDetailPage from "modules/order-page/order-detail";
import { AuthManagement } from "shared/components/auth-management/auth-management";
import { fetchAppData } from "shared/plugins/fetch-app-data";
import { getCaptchaRequest } from "states/global-value/global-value.slice";
if (process.env.NODE_ENV === "development") {
  require("./themes/css/variables.css");
}
function App() {
  useEffect(() => {
    store.dispatch(getCaptchaRequest());
    if(store.getState().globalValue.isSignIn){
      fetchAppData(store.dispatch)
    }
  }, []);
  return (
    <Provider store={store}>
      <Router history={history}>
        {process.env.NODE_ENV === "development" && (
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no,maximum-scale=1, user-scalable=no"
          ></meta>
        )}
        <Route path={EMPTY_ROUTE} exact={true} component={EmptyPage} />
        <AuthManagement>
          <LayoutInternalPage>
              <Route exact path={ACCOUNT_EDIT_ROUTE} component={UserInfoPage} />
              <Route exact path={ACCOUNT_CHANGE_PASSWORD_ROUTE} component={ChangePasswordPage} />
              <Route exact path={BILLING_ADDRESS_ROUTE} component={AddressPage} />
              <Route exact path={ORDER_ROUTE} component={OrderPage} />
              <Route exact path={`${ORDER_VIEW_ROUTE}/:id`} component={OrderDetailPage} />
              <Route exact path={BILLING_ADDRESS_ADD_ROUTE} component={AddUpdateAddressPage} />
              <Route exact path={`${BILLING_ADDRESS_EDIT_ROUTE}/:id`} component={AddUpdateAddressPage} />
              <Route exact path={SHIPPING_ADDRESS_ROUTE} component={AddressPage} />
              <Route exact path={SHIPPING_ADDRESS_ADD_ROUTE} component={AddUpdateAddressPage} />
              <Route exact path={`${SHIPPING_ADDRESS_EDIT_ROUTE}/:id`} component={AddUpdateAddressPage} />
            </LayoutInternalPage>
           
        </AuthManagement>
        <LayoutExternalPage>
           <Route exact path={ACCOUNT_LOGIN_ROUTE} >
              {store.getState().globalValue.isSignIn ? <Redirect to={ACCOUNT_EDIT_ROUTE} /> : <LoginPage />}
           </Route>
           <Route exact path={ACCOUNT_RESET_PASSWORD_ROUTE} component={ResetPasswordPage} />
           <Route exact path={ACCOUNT_FORGOT_PASSWORD_ROUTE} component={ForgotPasswordPage} />
           <Route exact path={ACCOUNT_REGISTER_ROUTE} component={RegisterPage} />
         </LayoutExternalPage>
        <Loading />
        <ConfirmModal />
        <ToastifyComponent />
      </Router>
    </Provider>
  );
}

export default App;
